import { Flex, FlexItem } from 'shared_DEPRECATED/components/Flex';
import { HotjarSuppression } from 'shared_DEPRECATED/components/Hotjar';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import { useCopyToClipboard } from 'shared_DEPRECATED/hooks';

import { AUTH_METHODS } from 'features/auth/config';

import { ButtonIcon } from 'shared/components/Button';
import { Typography } from 'shared/components/Typography';

type TParticipantCopyEmail = {
  email: string;
  authMethod?: AUTH_METHODS;
};

export const ParticipantCopyEmail = ({
  email,
  authMethod = AUTH_METHODS.EMAIL,
}: TParticipantCopyEmail) => {
  const copyTextToClipboard = useCopyToClipboard({
    clipboardText: email,
    clipboardTextName: 'user email',
  });

  const authMethodIcon = iconsMap[authMethod] || iconNames.email;

  return (
    <>
      {email ? (
        <Flex justifyContent="space-between">
          <FlexItem flexShrink={0}>
            <Icon width="16px" height="16px" name={authMethodIcon} />
          </FlexItem>
          <Typography type="small" cropped={true} color="gray">
            <HotjarSuppression as="span">{email}</HotjarSuppression>
          </Typography>
          <FlexItem>
            <ButtonIcon
              aria-label="copy email"
              onClick={copyTextToClipboard}
              variant="ghost"
              size="sm"
            >
              <Icon name={iconNames.copy} stroke="var(--fgSecondary)" />
            </ButtonIcon>
          </FlexItem>
        </Flex>
      ) : null}
    </>
  );
};

const iconsMap = {
  [AUTH_METHODS.GOOGLE]: iconNames.google,
  [AUTH_METHODS.APPLE]: iconNames.apple,
  [AUTH_METHODS.EMAIL]: iconNames.email,
};
